import Legend from "../vis/Legend";
import MinimalDistributionChart from "../vis/MinimalDistributionChart";
import ChartInteraction from "../vis/ChartInteraction";

export default class MapVisConfig {
  #layerConfig: any;

  constructor() {
    this.#layerConfig = {};
    this.#init();
  }

  #init() {
    const that = this;

    [
      "Squares",
      "Buildings",
      "Municipality-boundaries",
      "IsochronePoiSec",
      "IsochronePoiMeter",
    ].forEach((visFeature) => {
      that.#layerConfig[visFeature] = {};
    });

    ["Squares", "Buildings"].forEach((visFeature) => {
      that.#layerConfig[visFeature].legend = new Legend(
        `#legendWrapper${visFeature}`
      );
      that.#layerConfig[visFeature].legendChart = new MinimalDistributionChart(
        `#legendChart${visFeature}`
      );
    });

    that.#layerConfig["Squares"].interaction = ChartInteraction.getInstance(); //new ChartInteraction(`#interactionControlSquares`, 'Squares');

    that.#layerConfig["Squares"].colorScheme = "blues";
    that.#layerConfig["Buildings"].colorScheme = "reds";

    that.#layerConfig["Squares"].layerTemplate = {
      type: "fill",
      paint: {
        "fill-color": ["get", "color"],
        "fill-opacity": 1,
        "fill-outline-color": [
          "interpolate",
          ["exponential", 0.5],
          ["zoom"],
          13,
          "rgba(0,0,0,0)",
          16,
          "rgba(0,0,0,1)",
        ],
      },
    };

    that.#layerConfig["Squares"].layerTemplateAggregate = {
      type: "fill",
      paint: {
        "fill-color": ["get", "color"],
        "fill-opacity": 0.8,
        "fill-outline-color": [
          "interpolate",
          ["exponential", 0.5],
          ["zoom"],
          9,
          "rgba(0,0,0,0)",
          10,
          "rgba(0,0,0,1)",
        ],
      },
    };
    that.#layerConfig["Buildings"].layerTemplate = {
      type: "fill-extrusion",
      paint: {
        "fill-extrusion-color": ["get", "color"],
        "fill-extrusion-opacity": 1,
        "fill-extrusion-height": 2,
        "fill-extrusion-base": ["get", "base_height"],
      },
      filter: ["==", ["get", "selected"], true],
    };

    that.#layerConfig["IsochronePoiSec"].layerTemplate = {
      id: "isochronePoi",
      type: "fill",
      paint: {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["get", "reachability"],
          300,
          "#fde725",
          600,
          "#c2df23",
          900,
          "#86d549",
          1200,
          "#52c569",
          1500,
          "#2ab07f",
          1800,
          "#1e9b8a",
          2100,
          "#25858e",
          2400,
          "#2d708e",
          2700,
          "#38588c",
          3000,
          "#433e85",
          3300,
          "#482173",
          3600,
          "#440154",
        ],
        "fill-opacity": 0.5,
      },
    };

    that.#layerConfig["IsochronePoiMeter"].layerTemplate = {
      id: "isochronePoi",
      type: "fill",
      paint: {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["get", "reachability"],
          100,
          "#fde725",
          200,
          "#c2df23",
          300,
          "#86d549",
          400,
          "#52c569",
          500,
          "#2ab07f",
          750,
          "#1e9b8a",
          1000,
          "#25858e",
          1500,
          "#2d708e",
          2000,
          "#38588c",
          3000,
          "#433e85",
          4000,
          "#482173",
          5000,
          "#440154",
        ],
        "fill-opacity": 0.5,
      },
    };

    var srcAndLayerName = "Municipality-boundaries";
    that.#layerConfig[srcAndLayerName].layerTemplate = {
      id: srcAndLayerName,
      type: "line",
      source: srcAndLayerName,
      paint: { "line-color": "rgba(0, 0, 0,1)", "line-width": 3 },
    };

    that.#layerConfig["Squares"].paintFunction = function (
      map: any,
      layerName: string
    ) {
      map.setPaintProperty(layerName, "fill-color", ["get", "color"]);
    };

    that.#layerConfig["Buildings"].paintFunction = function (
      map: any,
      layerName: string
    ) {
      map.setPaintProperty(layerName, "fill-extrusion-color", ["get", "color"]);
    };
  }

  getLayerOrder() {
    return [
      "Municipality-boundaries",
      "indicatorSquares",
      "indicatorBuildings",
      "customlyDrawnPolys",
      "customlyDrawnLines",
      "isochronePoi",
      "isochrone1",
      "isochrone9",
      "isochrone14",
      "isochrone19",
    ];
  }

  getLayerConfig() {
    return this.#layerConfig;
  }
}
